'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewToolbarComponent = exports.productOverviewToolbarComponent = {
    template: require('./product-overview-toolbar.html'),
    bindings: {
        paging: '=',
        sorting: '=',
        viewMode: '=',
        placement: '@',
        changeItemsPerPage: '&',
        goToPage: '&',
        changeSorting: '&',
        changeViewMode: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", function controller($scope) {
        'ngInject';

        var vm = this;
        vm.pagecountList = [24, 48, 72, 96, 120];
        vm.$onInit = init;

        /* view mode */
        function init() {
            $scope.$watch('vm.paging.itemsPerPage', function (newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    vm.changeItemsPerPage({ itemsPerPage: vm.paging.itemsPerPage });
                }
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-overview-toolbar.js
// module id = 979
// module chunks = 0